import React from "react";
import loyiaIcon from "../../assets/images/Loyia.png";

function LoyiaInlineIcon({ size = 24, className = "" }) {
  return (
    <img
      src={loyiaIcon}
      alt="LOYIA"
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        overflow: "hidden",
        lineHeight: 0,
        verticalAlign: "middle",
        
      }}
    />
  );
}

export default LoyiaInlineIcon;
